import { addToCart, addToFavorites } from './blocks';
import { uiPlus, dotsSVG, uiFavorite } from './svg';
var createAddToFavoritesButton = function (_a) {
    var id = _a.id, _b = _a.isFavorite, isFavorite = _b === void 0 ? false : _b;
    var button = document.createElement('button');
    button.setAttribute('data-id', id.toString());
    button.className = 'add-to-favorites';
    button.classList.toggle('active', isFavorite);
    button.innerHTML = uiFavorite;
    button.addEventListener('click', function (evt) { return addToFavorites({ evt: evt, button: button }); });
    return button;
};
export var createAddToCartButton = function (_a) {
    var id = _a.id, parentId = _a.parentId, inStock = _a.inStock, type = _a.type;
    var button = document.createElement('button');
    button.className = 'add-to-cart';
    if (type === 'variable' || type === 'bundle') {
        button.innerHTML = dotsSVG;
        button.setAttribute('data-action', 'permalink');
    }
    else {
        button.innerHTML = uiPlus;
        button.setAttribute('data-action', 'add-to-cart');
        button.addEventListener('click', function (evt) { return addToCart({ evt: evt, button: button }); });
    }
    if (parentId) {
        button.setAttribute('data-variation', id.toString());
        button.setAttribute('data-product', parentId.toString());
    }
    else {
        button.setAttribute('data-product', id.toString());
    }
    if (!inStock) {
        button.classList.add('out-of-stock');
    }
    return button;
};
var priceAmount = function (price) {
    var number = parseFloat(price);
    if (Number.isNaN(number))
        return null;
    var formattedPrice = number.toFixed(2).replace('.', ',');
    if (!formattedPrice)
        return null;
    var amount = document.createElement('span');
    amount.className = 'amount';
    amount.textContent = formattedPrice + ' €';
    return amount;
};
export var createPriceHtml = function (_a) {
    var price = _a.price, onSale = _a.onSale, regularPrice = _a.regularPrice, className = _a.className;
    var html = document.createElement('span');
    html.className = className;
    if (onSale) {
        var del = document.createElement('del');
        var salePriceHtml = priceAmount(regularPrice);
        if (salePriceHtml)
            del.appendChild(salePriceHtml);
        html.appendChild(del);
    }
    var ins = document.createElement('ins');
    var priceHTML = priceAmount(price);
    if (priceHTML)
        ins.appendChild(priceHTML);
    html.appendChild(ins);
    return html;
};
export var createProductCard = function (props) {
    var card = document.createElement('article');
    card.className = 'vape-shop-product-card';
    var cardTop = document.createElement('div');
    cardTop.className = 'vape-shop-product-card__top';
    var badges = document.createElement('div');
    badges.className = 'vape-shop-product-card__badges';
    if (props.badges)
        badges.innerHTML = props.badges;
    if (props.rating)
        badges.innerHTML += props.rating;
    cardTop.appendChild(badges);
    cardTop.appendChild(createAddToFavoritesButton({ id: props.id, isFavorite: props.isFavorite }));
    var link = document.createElement('a');
    link.href = props.url;
    link.className = 'vape-shop-product-card__link';
    var img = document.createElement('div');
    img.className = 'vape-shop-product-card__image';
    img.innerHTML = props.image;
    var info = document.createElement('div');
    info.className = 'vape-shop-product-card__info';
    if (props.ingredients)
        info.innerHTML = props.ingredients;
    var title = document.createElement('h3');
    title.className = 'vape-shop-product-card__title';
    title.textContent = props.name;
    var bottom = document.createElement('div');
    bottom.className = 'vape-shop-product-card__bottom';
    var productPrice = createPriceHtml({
        price: props.price,
        onSale: props.onSale,
        regularPrice: props.regularPrice,
        className: 'vape-shop-product-card__price',
    });
    bottom.appendChild(productPrice);
    bottom.appendChild(createAddToCartButton({
        id: props.id,
        parentId: props.parentId,
        inStock: props.inStock,
        type: props.type,
    }));
    info.appendChild(title);
    info.appendChild(bottom);
    img.appendChild(cardTop);
    link.appendChild(img);
    link.appendChild(info);
    card.appendChild(link);
    return card;
};
export var createCardLoader = function () {
    var card = document.createElement('div');
    card.classList.add('vape-shop-product-card-loader');
    var image = document.createElement('div');
    image.classList.add('vape-shop-product-card-loader__image');
    var title = document.createElement('div');
    title.classList.add('vape-shop-product-card-loader__title');
    var bottom = document.createElement('div');
    bottom.classList.add('vape-shop-product-card-loader__bottom');
    var price = document.createElement('div');
    price.classList.add('vape-shop-product-card-loader__price');
    var button = document.createElement('div');
    button.classList.add('vape-shop-product-card-loader__button');
    title.appendChild(document.createElement('span'));
    title.appendChild(document.createElement('span'));
    bottom.appendChild(price);
    bottom.appendChild(button);
    card.appendChild(image);
    card.appendChild(title);
    card.appendChild(bottom);
    return card;
};
